import { useState } from "react";
import { addEmployeeDefaults } from "../constants/formDefaults";
import { text as allText } from "../constants/text";

export const useAddEmployeeForm = (language) => {
  const t = allText[language];

  const [formData, setFormData]   = useState(addEmployeeDefaults);
  const [formErrors, setFormErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleFieldChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Clear error when field changes
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const errors = {};

    // ──────────────────────────────────────────────
    // Required Basic Information
    // ──────────────────────────────────────────────
    if (!formData.name || !formData.name.trim()) {
      errors.name = t.nameRequired || "Name is required";
    }

    // Email is no longer mandatory on its own — a login account can be
    // created from either an email or a phone number, so only require that
    // at least one of the two is present. Whichever IS provided still gets
    // format-checked.
    const hasEmail = !!(formData.email && formData.email.trim());
    const hasPhone = !!(formData.phone && formData.phone.trim());

    if (hasEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
      errors.email = t.emailInvalid || "Email is invalid";
    }

    if (!hasEmail && !hasPhone) {
      errors.email = t.emailOrPhoneRequired || "Email or phone number is required";
      errors.phone = t.emailOrPhoneRequired || "Email or phone number is required";
    }

    // ──────────────────────────────────────────────
    // Required Work Information
    // ──────────────────────────────────────────────
    // A department must be SELECTED — departmentId (from the API list) wins;
    // the plain name is only accepted as the fallback when no id list exists.
    // Error set under both keys so either FormField binding displays it.
    const hasDepartmentId =
      formData.departmentId !== null &&
      formData.departmentId !== undefined &&
      formData.departmentId !== "";
    if (!hasDepartmentId && (!formData.department || !formData.department.trim())) {
      errors.department = t.departmentRequired || "Department is required";
      errors.departmentId = errors.department;
    }

    if (!formData.position || !formData.position.trim()) {
      errors.position = t.positionRequired || "Position is required";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const resetForm = () => {
    setFormData(addEmployeeDefaults);
    setFormErrors({});
  };

  return {
    formData,
    formErrors,
    handleInputChange,
    handleFieldChange,
    validateForm,
    resetForm,
  };
};